// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.client-profile-page__header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--ds-space-4);
}

.client-profile-page__info {
  flex: 1 1 200px;
  min-width: 0;
  overflow-wrap: anywhere;
}

.client-profile-page__project {
  height: 100%;
  overflow-wrap: anywhere;
}

@media (max-width: 575.98px) {
  .client-profile-page__header {
    flex-direction: column;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/clients/ProjectsListView/ProjectsListView.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF","sourcesContent":[".client-profile-page__header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--ds-space-4);\n}\n\n.client-profile-page__info {\n  flex: 1 1 200px;\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.client-profile-page__project {\n  height: 100%;\n  overflow-wrap: anywhere;\n}\n\n@media (max-width: 575.98px) {\n  .client-profile-page__header {\n    flex-direction: column;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
